import { SvgIcon } from '@mui/material';

export default function EndIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 64 80" style={{ ...props.style }}>
      <path d="M50.82,5.02c-.33-.17-.72-.15-1.03,.06-.37,.25-9.11,6.04-17.19,.02-9.05-6.74-19-.37-19.5-.03-.01,0-.02,.01-.02,.01-.11,.08-.2,.18-.27,.29-.03,.05-.06,.09-.08,.14-.05,.12-.08,.26-.08,.4V61c0,.55,.45,1,1,1s1-.45,1-1V30.72c1.92-1.14,9.59-5.08,16.75,.26,3.1,2.31,6.31,3.08,9.21,3.08,5.73,0,10.24-3.01,10.31-3.06,.27-.19,.43-.49,.43-.83V5.91c0-.37-.2-.71-.53-.89Z" />
    </SvgIcon>
  );
}
